module.exports = __webpack_public_path__ + "static/media/title_bitwitches_collection.f2fc8dfa.svg";